import React from 'react';
import { Textarea, TextAreaProps } from '@heroui/react';
import Typography from './typography/Typography';
import { InfoCircle } from './icons';

interface CustomTextareaProps extends Omit<TextAreaProps, 'classNames'> {
  label: string;
  required?: boolean;
  error?: string;
  touched?: boolean;
  infoIcon?: boolean;
  className?: string;
}

const CustomTextarea: React.FC<CustomTextareaProps> = ({
  label,
  required = false,
  error,
  touched,
  infoIcon = true,
  className = '',
  ...textareaProps
}) => {
  const isPartner = window.location.pathname.startsWith('/partner');
  return (
    <div className={`gap-2 flex flex-col ${className}`}>
      <div className="flex items-center gap-1">
        <Typography
          variant="body2"
          className={error && touched ? 'text-auth-strength-weak' : 'text-auth-ink'}
        >
          {label}
          {required && (
            <span
              className={
                error && touched
                  ? 'text-auth-strength-weak'
                  : `${isPartner ? 'text-partner' : 'text-primary'}`
              }
            >
              *
            </span>
          )}
        </Typography>
      </div>
      <Textarea
        {...textareaProps}
        variant="bordered"
        className="w-full"
        classNames={{
          inputWrapper: `border-auth-strength-none rounded-lg ${error && touched ? 'border-auth-strength-weak' : ''}`,
        }}
      />
      {error && touched && (
        <Typography variant="body2" className="text-auth-strength-weak text-xs">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default CustomTextarea;
